import { useDispatch } from 'react-redux';
import { Responses } from 'actions/sharedJsActions';


import { useServerTime } from './helpers';

const {
  responseSync,
  responseEvaluate,
  responseEvaluateLocal,
  responseTimeSpent
} = Responses;

export function useQuizResponse(quizId, questionId, syncTimeout, timeSliceTime, exitOnError) {
  const dispatch = useDispatch();
  const getServerTimeNow = useServerTime();

  const evaluateResponse = (isSearch) => {
    if (isSearch) {
      return dispatch(responseEvaluateLocal(quizId, questionId));
    }
    return dispatch(responseEvaluate(quizId, questionId)).catch(exitOnError);
  };

  const syncResponse = ({ navigatingAway, isComplete }) => {
    if (isComplete) return Promise.resolve();

    if (syncTimeout.current) {
      clearTimeout(syncTimeout.current);
      syncTimeout.current = null;
    }

    const timeDiff = getServerTimeNow().toJSDate() - timeSliceTime.current;
    const timeSliceTimePrevious = timeSliceTime.current;
    timeSliceTime.current = getServerTimeNow().toJSDate();

    return dispatch(responseSync(quizId, questionId, navigatingAway ? 'navigated_away' : 'answered', timeDiff, true))
      .catch((error) => {
        timeSliceTime.current = timeSliceTimePrevious;
        exitOnError(error);
      });
  };

  const syncTimeSpent = (isComplete) => {
    if (isComplete) return Promise.resolve();

    if (syncTimeout.current) {
      clearTimeout(syncTimeout.current);
      syncTimeout.current = null;
    }

    const timeDiff = getServerTimeNow().toJSDate() - timeSliceTime.current;
    timeSliceTime.current = getServerTimeNow().toJSDate();
    return dispatch(responseTimeSpent(quizId, questionId, 'navigated_away', timeDiff));
  };
  return { syncTimeSpent, syncResponse, evaluateResponse };
}
